import { REDUCED } from "./shared";

/* The RIPP 2.0 command-center render (8s loop, muted). Poster fallback + reduced-motion = still frame. */
export const CoreVideo = ({ className = "", style, testid = "core-video" }) => (
  REDUCED ? <img src="/ripp-core-poster.jpg" alt="RIPP command center" className={className} style={style} data-testid={testid} />
    : (
      <video className={className} style={style} autoPlay muted loop playsInline preload="metadata" poster="/ripp-core-poster.jpg" data-testid={testid}>
        <source src="/ripp-core.webm" type="video/webm" />
        <source src="/ripp-core.mp4" type="video/mp4" />
      </video>
    )
);
